import { Select } from '@truepill/react-capsule'
import { getAdornment } from '../CreateRuleSetPage'

const VALUES_TYPE_OPTIONS = [
  { label: 'String', value: 'string' },
  { label: 'Array', value: 'array' },
]

const ValuesTypeSelect = ({
  value,
  onChange,
  state,
  helperText,
}: {
  value: string
  onChange: (val: string) => void
  state: 'error' | 'default'
  helperText?: string
}) => {
  return (
    <Select
      label="Values Type"
      value={VALUES_TYPE_OPTIONS.find(opt => opt.value === value) || null}
      onChange={selected => {
        if (!selected) return
        onChange(selected.value)
      }}
      options={VALUES_TYPE_OPTIONS}
      selectedKey="label"
      state={state}
      helperText={helperText}
      endAdornment={getAdornment(
        'Select "string" if the value you’re comparing is a single value, which enables operators for single-value comparisons. Select "array" if you’re checking against a list of values.',
      )}
    />
  )
}

export default ValuesTypeSelect
